export const groupToMap = <DataType>(
  data: DataType[],
  groupBy: (data: DataType) => string | number
): Map<string, DataType[]> => {
  return data.reduce((acc, value) => {
    const expectedGroupKey = `${groupBy(value)}`;
    const existingGroup = acc.get(expectedGroupKey);
    acc.set(expectedGroupKey, existingGroup ? [...existingGroup, value] : [value]);

    return acc;
  }, new Map<string, DataType[]>());
};
